module.exports = __webpack_public_path__ + "img/12.1fc90579.png";